import {Component, OnInit, ViewChild, Input} from '@angular/core';

@Component({
  selector: 'nuc-schema-preview-popup',
  templateUrl: './schema-preview-popup.component.html',
  styleUrls: ['./schema-preview-popup.component.scss']
})
export class SchemaPreviewPopupComponent implements OnInit {

  @ViewChild('preview') preview;
  @Input() schema = { description:'' , name :'', attributes:[], location:[]};
  isSubmitted: boolean;
  copied;
  constructor() { }

  ngOnInit() { }

  open(){
    this.copied = false;
    this.preview.open();
  }


}



// WEBPACK FOOTER //
// ./src/app/schema/shared/schema-preview-popup/schema-preview-popup.component.ts